import React from "react";
import { useEffect, useState, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import ReactGA from "react-ga4";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTwitter, faFacebookF, faPinterestP } from "@fortawesome/free-brands-svg-icons";/
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Layout from '../components/layout';
import { config } from '../utils/constants';
// import logo from '../assets/images/logos/LOGO-White.png'/
import bag1 from '../assets/images/bag1.png';
import bag2 from '../assets/images/bag2.png';
import bag3 from '../assets/images/bag3.png';
import bag1hover from '../assets/images/bag1-hover.png';
import bag2hover from '../assets/images/bag2-hover.png';
import bag3hover from '../assets/images/bag3-hover.png';
import videoSource from '../assets/videos/bagvideo.mp4';
import { faHeart as faHeartFilled } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartOutline } from "@fortawesome/free-regular-svg-icons";




const ProductCard = ({ defaultImage, hoverImage, title, description, isInView }) => {
  const [liked, setLiked] = useState(false);

  const handleLike = () => {
    setLiked(!liked);
  };

  return (
    <div className={`card product-card ${isInView ? "fly-in" : ""}`}>
      <div className="image-container">
        <img
          src={defaultImage}
          alt={title}
          className="default-image card-img-top"
        />
        <img
          src={hoverImage}
          alt={`${title} Hover`}
          className="hover-image card-img-top"
        />
      </div>
      <div className="card-body text-container">
        {/* Like Icon */}
        <div className="like-icon" onClick={handleLike}>
          <FontAwesomeIcon icon={liked ? faHeartFilled : faHeartOutline} />
        </div>
        <h5 className="card-title">{title}</h5>
        <p className="card-text">{description}</p>
      </div>
    </div>
  );
};



  const SignupSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("First name is required"),
    lastName: Yup.string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Last name is required"),
    email: Yup.string()
      .email("Invalid email")
      .required("Email is required"),
  });

const Home = () => {
const [searchParams] = useSearchParams();
const campaignId = searchParams.get('campaignId');
const [isSticky, setIsSticky] = useState(false);

const heroRef = useRef(null); // Ref for hero section
  ReactGA.send({
    hitType: 'pageview',
    page: `/${campaignId || ''}`, // Dynamically include campaignId if it exists
    title: 'Page Visit',
    customData: {
      source: campaignId ? config.funnel[campaignId.split('-')[0]] : "Direct visit",
      campaign_id: campaignId ? campaignId.split('-')[1] : "None",
    },
  });

  var REACT_APP_API_URL = config.url.REACT_APP_API_URL
  // const [message, setMessage] = useState("");
  // const [loading, setLoading] = useState(false);
  const [serverMessage, setServerMessage] = useState(null); // State to hold the server message


  const handleSubmit = (values, { resetForm }) => {
      axios
        .post(
          `${REACT_APP_API_URL}/capture/`,
          { first_name: values.firstName,
            last_name: values.lastName,
            email: values.email,
            type: 'info',},
          { withCredentials: true }
        )
        .then((res) => {
          setServerMessage(res.data.message); // Set the server's response message
          resetForm(); // Reset the form
          ReactGA.event({
            category: 'engagement',
            action: 'form_submission',
            label: 'Pre Product Release Form',
          });
        })
        .catch((err) => {
          if (err.response) {
            if (err.response && err.response.status === 409) {
              setServerMessage("Thank you. We will let you know when our bags will be available.");
              // setLoading(false);
            }
          }
        });
      // resetForm(); // Reset the form after submission
    };
  const [isAboutVisible, setIsAboutVisible] = useState(false);
  const [isCollectionTitleVisible, setIsCollectionTitleVisible] = useState(false);
  const [visibleCards, setVisibleCards] = useState([]);

  // const [isCollectionTitleVisible, setIsCollectionTitleVisible] = useState(false);
  // const [visibleCards, setVisibleCards] = useState([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const targetId = entry.target.id;
          const index = entry.target.getAttribute("data-index");

          if (entry.isIntersecting) {
            if (targetId === "collection-title") {
              setIsCollectionTitleVisible(true);
            }
            if (index !== null) {
              setVisibleCards((prev) => [...new Set([...prev, index])]);
            }
            if (targetId === "about") {
              setIsAboutVisible(true);
            }
          }
        });
      },
      { threshold: 0.3 } // Trigger when 30% of the element is visible
    );

    const aboutSection = document.querySelector("#about");
    if (aboutSection) observer.observe(aboutSection);
    // Observe Collection Title
    const collectionTitle = document.querySelector("#collection-title");
    if (collectionTitle) observer.observe(collectionTitle);

    // Observe Product Cards
    const productCards = document.querySelectorAll(".product-card");
    productCards.forEach((card, index) => {
      card.setAttribute("data-index", index);
      observer.observe(card);
    });

    return () => {
      if (aboutSection) observer.unobserve(aboutSection);
      if (collectionTitle) observer.unobserve(collectionTitle);
      productCards.forEach((card) => observer.unobserve(card));
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
        ([entry]) => {
            setIsSticky(!entry.isIntersecting); // Set isSticky true as soon as hero starts to scroll
        },
        { threshold: 0.88 } // Triggers when any part of the hero starts leaving the viewport
    );

    if (heroRef.current) {
        observer.observe(heroRef.current);
    }

    return () => {
        if (heroRef.current) {
            observer.unobserve(heroRef.current);
        }
    };
}, []);

  return (
    <div className="home-content">
      <Layout>
      <div className={`blur-overlay ${isSticky ? 'fix-menu-desktop' : ''}`}></div>

      {/* Hero Section */}
      <section ref={heroRef} className="hero">
        <div className="video-container">
          <video autoPlay loop muted playsInline className="hero-video">
            <source src={videoSource} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="video-overlay">
            <p className="hero-subtitle">
            </p>
            <a href="#products" className="btn btn-primary">
              Explore Collection
            </a>
          </div>
        </div>
      </section>

      {/* Product Highlights */}
      <section className="products py-5" id="products">
      <div className="container">
          {/* Collection Title */}
          <h2
            id="collection-title"
            className={`collection-title text-center mb-5 ${
              isCollectionTitleVisible ? "fly-in" : ""
            }`}
          >
            Our Collection
          </h2>

          {/* Product Cards */}
          <div className="row">
            {[
              { defaultImage: bag1, hoverImage: bag1hover, title: "Chic Urban Tote", description: "A perfect blend of style and practicality, the Chic Urban Tote offers spacious compartments for your daily essentials. Crafted from premium leather, it's designed to keep you fashionable on the go." },
              { defaultImage: bag2, hoverImage: bag2hover, title: "Elegant Evening Clutch", description: "Add a touch of sophistication to your night out with the Elegant Evening Clutch. Featuring a sleek design and shimmering accents, this purse is the ultimate accessory for special occasions." },
              { defaultImage: bag3, hoverImage: bag3hover, title: "Classic Satchel Bag", description: "Timeless and versatile, the Classic Satchel Bag combines functionality with understated elegance. Its structured silhouette and multiple pockets make it ideal for both work and casual outings." },
            ].map((bag, index) => (
              <div className="col-md-4" key={index}>
                <ProductCard
                  defaultImage={bag.defaultImage}
                  hoverImage={bag.hoverImage}
                  title={bag.title}
                  description={bag.description}
                  isInView={visibleCards.includes(index.toString())}
                />
              </div>
            ))}
            <div id="signup"></div>
          </div>
        </div>
      </section>

{/* Signup Section */}
<div className="focus-section">
    <section className="signup py-5" id="signup-anchor">
      <div className="container">
        {serverMessage ? ( // Check if a server message exists
          <div className="text-center">
            <h2 className="text-success">{serverMessage}</h2>
          </div>
        ) : (
          <>
            <h2 className="text-center mb-4">
              Be the first to know when the Molu collection will be available!
            </h2>
            <Formik
              initialValues={{
                firstName: "",
                lastName: "",
                email: "",
              }}
              validationSchema={SignupSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form className="signup-form">
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <Field
                        type="text"
                        name="firstName"
                        className="form-control"
                        placeholder="First Name"
                      />
                      <ErrorMessage
                        name="firstName"
                        component="div"
                        className="text-danger mt-1"
                      />
                    </div>
                    <div className="col-md-6">
                      <Field
                        type="text"
                        name="lastName"
                        className="form-control"
                        placeholder="Last Name"
                      />
                      <ErrorMessage
                        name="lastName"
                        component="div"
                        className="text-danger mt-1"
                      />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <Field
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Email Address"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-danger mt-1"
                      />
                    </div>
                  </div>
                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={isSubmitting}
                    >
                      Notify Me
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </>
        )}
      </div>
    </section>
    </div>
      {/* About Section */}
      <section
        id="about"
        className={`about-section py-5 ${isAboutVisible ? "zoomed" : ""}`}
        style={{
          backgroundImage: `url(${require("../assets/images/arches-bags.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "500px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          color: "#f2e8df",
        }}
      >
        <div className="about-overlay">
          <h2 className="about-title">The Epitome of Elegance and Craftsmanship</h2>
          <a href="#about-us" className="btn btn-primary about-button">
            About Us
          </a>
        </div>
      </section>
      <div>
      {/* Off-white Section Above Footer */}
      <div className="footer-above py-4">
        <div className="container text-center">
        </div>
      </div>

      
    </div>
    </Layout>
    </div>
  );
};

export default Home;
